// removed by extract-text-webpack-plugin
module.exports = {"ldt":"gb_gc","container":"gb_g","header":"gb_bg gb_g","avatar":"gb_fm","carouselHeading":"gb_ge","carouselMore":"gb_gf","pageHeading":"gb_gg","eventTitle":"gb_gh","link":"gb_cx","eventDetailContainer":"gb_gi","eventDetails":"gb_gj","breaker":"gb_gk","breakerSmall":"gb_gl gb_gk","masonry":"gb_gm"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventReview/styles.module.css
// module id = 1322
// module chunks = 27